export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 border-t border-gray-800 text-white mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-xl font-bold text-bitcoin">
            C₿R
          </div>

          <div className="text-gray-400 text-sm">
            &copy; {currentYear} Community Bitcoin Reserve
          </div>
        </div>
      </div>
    </footer>
  )
}
